import { useContext } from 'react';
import { AppContext } from 'context';

const useContextService = () => useContext(AppContext);

export default useContextService;